













import { Prop, Component, Vue } from "vue-property-decorator";

interface SubTask {
  id: number;
  name: string;
  done: boolean;
  dueDate: Date;
}

@Component({})
export default class SubTaskListItem extends Vue {
  @Prop({ required: true }) item!: SubTask;
}
